import { useNavigate } from "react-router-dom";
import {
  ShieldCheck,
  ClipboardList,
  Megaphone,
  BarChart2,
} from "lucide-react";

const quickAccessItems = [
  { path: "/safetytask", icon: ShieldCheck, label: "Safety\nTask" },
  { path: "/tenantrequest", icon: ClipboardList, label: "Tenant\nRequest" },
  { path: "/announcements", icon: Megaphone, label: "Announce\nments" },
  { path: "/tenant-relation/visitor", icon: BarChart2, label: "Mall\nTraffic" },
];

export default function QuickAccessSection() {
  const navigate = useNavigate();

  return (
    <div className="h-full flex flex-col w-full flex-1">
      <div className="rounded-2xl bg-white p-6 shadow-sm border border-gray-200 dark:border-gray-700 dark:bg-gray-900 flex flex-col h-full flex-1">
        <div className="flex items-center justify-between mb-8">
          <h3 className="text-base font-semibold text-gray-900 dark:text-white">
            Quick Access
          </h3>
        </div>

        <div className="grid grid-cols-4 gap-6">
          {quickAccessItems.map((item) => {
            const Icon = item.icon;

            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center gap-3"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full dark:bg-gray-800">
                  <Icon
                    size={22}
                    className="text-blue-600 dark:text-blue-400"
                  />
                </div>

                <span className="text-[11px] font-semibold text-gray-900 dark:text-white text-center leading-tight">
                  {item.label.split("\n").map((line, i, arr) => (
                    <span key={i}>
                      {line}
                      {i < arr.length - 1 && <br />}
                    </span>
                  ))}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}